import get from "lodash/get";
import rill from "rill";
import redirect from "@rill/redirect";

import maintenanceMode from "../middleware/maintenance-mode";

import ensureUser from "../middleware/ensure-user";
import ensureSetup from "../middleware/ensure-setup";
import ensurePaid from "../middleware/ensure-paid";

import Admin from "./admin";
import Login from "./login";
import LoginNewOnboarding from "./login-new-onboarding";
import Forgot from "./forgot";
import Signup from "./signup";
import SignupCoach from "./signup-coach";
import SignupCoachOrganization from "./signup-coach-organization";
import OnboardingBranding from "./onboarding-branding";
import OnboardingExerciseLibrary from "./onboarding-exercise-library";
import UpdatePassword from "./update-password";
import Setup from "./setup";
import Dashboard from "./dashboard";
import Share from "./share";
import NotFound from "./not-found";
import AccessDenied from "./access-denied";
import Feedback from "./feedback";
import Upgrade from "./upgrade";
import Upgrade1 from "./upgrade-1";
import Upgrade2 from "./upgrade-2";
import UpgradeCoach from "./upgrade-coach";
import CoachBilling from "./coach-billing";
import Maintenance from "./maintenance";
import PrivacyPolicy from "./privacy-policy";
import TermsOfUse from "./terms-of-use";
import AthletePortal from "./athlete-portal";
import CoachingPortal from "./coaching-portal";
import AddToCalendar from "./add-to-calendar";
import Docs from "./docs/docs";

const Views = (app) => {
  app
    .get("/health-check", ({ res }) => (res.body = "I'm alive!"))
    /**
     * Provde domain ownership for "loader.io" which does load testing.
     * http://loader.io/
     */
    .get(
      "/loaderio-bf33d659bfd5b75e1bc28d209e05f988",
      ({ res }) => (res.body = "loaderio-bf33d659bfd5b75e1bc28d209e05f988")
    ) //prod
    .get(
      "/loaderio-0b764bc163b14b5b7952b98998604505",
      ({ res }) => (res.body = "loaderio-0b764bc163b14b5b7952b98998604505")
    ) //staging
    .get(
      "/loaderio-f0fcb8e10671d36b70334d3da7545673",
      ({ res }) => (res.body = "loaderio-f0fcb8e10671d36b70334d3da7545673")
    ) //CP
    .get(maintenanceMode)
    .get("/", redirect("/coaching-portal"))
    .setup(Admin)
    .setup(Login)
    .setup(LoginNewOnboarding)
    .setup(Forgot)
    .setup(Signup)
    .setup(SignupCoach)
    .setup(SignupCoachOrganization)
    .setup(OnboardingBranding)
    .setup(OnboardingExerciseLibrary)
    .setup(UpdatePassword)
    .setup(Setup)
    .setup(AthletePortal)
    .setup(Dashboard)
    .setup(CoachingPortal)
    .setup(Share)
    .setup(NotFound)
    .setup(AccessDenied)
    .setup(PrivacyPolicy)
    .setup(TermsOfUse)
    .setup(Feedback)
    .setup(Upgrade)
    .setup(Upgrade1)
    .setup(Upgrade2)
    .setup(UpgradeCoach)
    .setup(CoachBilling)
    .setup(Maintenance)
    .setup(Docs)
    .at("/add-to-calendar", ensureUser, ensurePaid, rill().setup(AddToCalendar))
    .get(redirect("/404"));
};

export default Views;
